import { Tab, withStyles } from '@material-ui/core'
import { GRAY_COLORS, INFO_COLORS } from 'asterX-UI/colors.constant'
import { secondaryB } from 'lib/constants/colors'
import React from 'react'

const AsterTab = withStyles(theme => ({
  root: {
    textTransform: 'none',
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    paddingBottom: 12,
    height: 41,
    borderRadius: '8px 8px 0 0',
    fontWeight: 600,
    color: GRAY_COLORS[500],
    opacity: 1,
    minWidth: 'max-content',
    '&:hover': {
      backgroundColor: secondaryB,
      borderBottom: '1px solid ' + INFO_COLORS[600],
      color: INFO_COLORS[600]
    },
    '&$selected': {
      borderBottom: '3px solid ' + INFO_COLORS[600],
      color: INFO_COLORS[600],
      fontWeight: 700,
      '&:hover': {
        backgroundColor: secondaryB
      }
    },
    '&:focus': {
      color: INFO_COLORS[600]
    }
  },
  selected: {}
}))(props => <Tab {...props} />)
export default AsterTab
